import { AxiosInstance } from 'axios';
import { ParametersList } from 'types/trackmanParameters';
import { Result } from 'services/Result';
import i18next from 'i18next';

export class TrackmanParametersService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getTrackmanParameters = async () => {
      const response = await this.axiosInstance.get<Result<ParametersList>>(`api/trackman-parameters`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(i18next.t('ErrorWhileFetchingParametersData', { ns: 'trackmanParameters' }));
  };
}

export default TrackmanParametersService;
